import { Component, OnInit, Inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { apiUrl } from "../../global/global";
import { AdminService } from "../../services/admin.service";
import { ActivatedRoute } from '@angular/router';
import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { TransferState, makeStateKey } from '@angular/platform-browser';


const DATA_KEY = makeStateKey<any>('data');


@Component({
  selector: 'app-mobile-faq',
  templateUrl: './mobile-faq.component.html',
  styleUrls: ['./mobile-faq.component.css']
})


export class MobileFaqComponent implements OnInit {


  text: string = "Loading...";

  faqList: any[] = [];

  language: any = '';

  language1: any;


  // Control del acordeón
  showThis: number = -1;

  show: boolean = false;


  constructor(
    private api: AdminService,
    private route: ActivatedRoute,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: Object

  ) {}


  ngOnInit(): void {


    let language:any = localStorage.getItem('language');


    this.language1 = language == 1 ? 1 : 2;


    this.language = this.route.snapshot.paramMap.get('id');



    if(isPlatformServer(this.platformId)){


      this.getFaq();


    }else{


      this.faqList = this.transferState.get(DATA_KEY, []);


      if(!this.faqList){

        this.getFaq();

      }

    }


  }



  getFaq(): void {


    let params = new HttpParams();



    this.api.getDataWithoutLoader(apiUrl._getFaq, params)
      .subscribe((res:any)=>{


        if(res){


          this.faqList = res.data || [];


          this.transferState.set(DATA_KEY, this.faqList);



          this.text = this.language1 == 2
          ? 'No records found'
          : this.language1 == 1
            ? 'No se encontraron registros'
            : 'Nenhum registro foi encontrado';


        }


      });


  }



  toggleFaq(index:number): void {


    if(this.showThis === index && this.show === true){


      this.show = false;

      this.showThis = -1;


    }else{


      this.showThis = index;

      this.show = true;


    }


  }




  langugaeCheck(item:any){


    if(this.language == 1){


      return item.question_spanish != null
      ? item.question_spanish
      : item.question_english != null
        ? item.question_english
        : item.question_portugese;


    }


    if(this.language == 2){


      return item.question_english != null
      ? item.question_english
      : item.question_spanish != null
        ? item.question_spanish
        : item.question_portugese;


    }


    return '';

  }





  langugaeCheck2(item:any){


    if(this.language == 1){


      return item.answer_spanish != null
      ? item.answer_spanish
      : item.answer_english != null
        ? item.answer_english
        : item.answer_portugese;


    }


    if(this.language == 2){


      return item.answer_english != null
      ? item.answer_english
      : item.answer_spanish != null
        ? item.answer_spanish
        : item.answer_portugese;


    }


    return '';

  }


}